module.exports = __webpack_public_path__ + "res/4-img_game_bg_q_m.f4bc6135980f6a6bea91bd9cb662bc96.png";